<template>
  <div class="page touzibaogao-moban">
    <header class="header">
      <div class="brand">
        <div class="logo">
          <svg width="28" height="28" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 4C16.27 4 10 10.27 10 18v2c0 4.42 2.08 8.34 5.29 10.9L14 38c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-1.29-7.1C35.92 28.34 38 24.42 38 20v-2c0-7.73-6.27-14-14-14z"
                  stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
            <path d="M18 42h12" stroke="white" stroke-width="3.5" stroke-linecap="round" />
            <line x1="24" y1="38" x2="24" y2="42" stroke="white" stroke-width="3.5" stroke-linecap="round" />
            <path d="M18 18l4 4 8-8" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div>
          <h1>投顾建议</h1>
          <p>策略结果总览</p>
        </div>
      </div>
      <div class="time">生成时间：{{ generateTime }}</div>
    </header>

    <section class="hero-card">
      <div class="hero-left">
        <div :class="['warn-icon', verdictClass]">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 4L6 12v10c0 11.05 7.16 21.42 18 24 10.84-2.58 18-12.95 18-24V12L24 4z" stroke="white"
                  stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
            <path d="M18 24l4 4 8-8" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div :class="verdictClass">
          <div :class="['status-pill', verdictClass]">{{ formatVerdict(verdict) }}</div>
          <h2>
            {{ yaliceshiResult.customerEvaluation.dimensions[0].insight }}

          </h2>
          <!-- <p v-if="verdict == 'optimize' && (zdhcIsPass == false || tzqxIsPass == false)">
            当前组合{{ zdhcIsPass == true ? '' : '最大回撤未通过，' }}
            {{ tzqxIsPass == true ? '' : '投资期限严重不匹配超出20%，' }}
            建议优化配置后再继续。
          </p>
          <p v-else-if="verdict == 'redo' && zdhcIsPass == false && tzqxIsPass == false">
            当前组合{{ zdhcIsPass == true ? '' : '最大回撤未通过，' }},
            {{ tzqxIsPass == true ? '' : '投资期限严重不匹配超出20%，' }},
            建议重新优化配置后再继续。
          </p>
          <p v-else>
            已全部达标，无需优化。
          </p> -->

          <p>{{ tishixinxi }}</p>


        </div>
      </div>
      <div class="hero-graphic">
        <div class="bar b1"></div>
        <div class="bar b2"></div>
        <div class="bar b3"></div>
        <div class="down-arrow">↘</div>
      </div>
    </section>

    <section class="kpi-grid">
      <div class="kpi-card danger">
        <div class="kpi-icon">
          <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29 34.9999H41V23" stroke="#e73546" stroke-width="4" stroke-linecap="round"
                  stroke-linejoin="round" />
            <path d="M6 13L16.3385 25.5L26.1846 19.5L41 35" stroke="#e73546" stroke-width="4" stroke-linecap="round"
                  stroke-linejoin="round" />
          </svg>
        </div>
        <div>
          <p>期望年化收益</p>
          <strong class="pass-tag" :class="qwnhIsPass ? 'pass-green' : 'pass-red'">{{ qwnhIsPass ? '已达标' : '不足'
          }}</strong>
          <em>目标:{{ backtestResult.customerEvaluation.dimensions[0].target }}% - 实际:{{
            backtestResult.customerEvaluation.dimensions[0].actual }}%</em>
        </div>
      </div>

      <div class="kpi-card blue">
        <div class="kpi-icon">
          <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 4L6 12v10c0 11.05 7.16 21.42 18 24 10.84-2.58 18-12.95 18-24V12L24 4z" stroke="#246bff"
                  stroke-width="4" stroke-linecap="round" stroke-linejoin="round" fill="none" />
            <path d="M20 28l4 4 8-8" stroke="#246bff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div>
          <p>最大回撤</p>
          <strong class="pass-tag" :class="zdhcIsPass ? 'pass-green' : 'pass-red'">{{ zdhcIsPass ? '已达标' : '不足'
            }}</strong>
          <em>上限:{{ yaliceshiResult.customerEvaluation.dimensions[0].target }}% - 实际:{{
            yaliceshiResult.customerEvaluation.dimensions[0].actual }}%</em>
        </div>
      </div>

      <div class="kpi-card green">
        <div class="kpi-icon">
          <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29 13H41V25" stroke="#14905c" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6 35L16.3385 22.5L26.1846 28.5L41 13" stroke="#14905c" stroke-width="4" stroke-linecap="round"
                  stroke-linejoin="round" />
          </svg>
        </div>
        <div>
          <p>投资期限</p>
          <strong class="pass-tag" :class="tzqxIsPass ? 'pass-green' : 'pass-red'">{{ tzqxIsPass ? '已达标' : '不足'
          }}</strong>
          <em>目标:{{ backtestResult.customerEvaluation.dimensions[2].target }}年 - 实际:{{
            backtestResult.customerEvaluation.dimensions[2].actual }}年</em>
        </div>
      </div>

      <div class="kpi-card orange">
        <div class="kpi-icon">
          <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 4C16.27 4 10 10.27 10 18v8c0 4.42 2.08 8.34 5.29 10.9L14 42h20l-1.29-5.1C35.92 34.34 38 30.42 38 26v-8c0-7.73-6.27-14-14-14z"
                  stroke="#eb7a21" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" fill="none" />
            <path d="M18 42h12" stroke="#eb7a21" stroke-width="4" stroke-linecap="round" />
            <path d="M24 34v-8" stroke="#eb7a21" stroke-width="4" stroke-linecap="round" />
            <circle cx="24" cy="20" r="2" fill="#eb7a21" />
          </svg>
        </div>
        <div>
          <p>流动性需求</p>
          <strong class="pass-tag" :class="ldxxqIsPass ? 'pass-green' : 'pass-red'">{{ ldxxqIsPass ? '已达标' : '不足'
            }}</strong>
          <em>上限:{{ yaliceshiResult.customerEvaluation.dimensions[1].target }}% - 实际:{{
            yaliceshiResult.customerEvaluation.dimensions[1].actual }}%</em>
        </div>
      </div>
    </section>

    <main class="main-grid">
      <section class="card income-card">
        <div class="section-title">
          <span></span>
          <h3>收益情景概览</h3>
        </div>

        <div class="income-content">
          <div class="chart-box">
            <div class="chart">
              <!-- <div v-for="item in scenarios" :key="item.scenario" class="chart-item">
                <div class="value">{{ item.annualReturn }}</div>
                <div class="bar-col" :style="{ height: getBarHeight(item.annualReturn) }"></div>
                <div class="label">{{ item.shortName }}</div>
              </div> -->
              <div class="chart-item">
                <div class="value">{{ TZBGParams.calculatedRules.futureReturns.pessimistic.annual }}</div>
                <div class="bar-col"
                     :style="{ height: getBarHeight(TZBGParams.calculatedRules.futureReturns.pessimistic.annual) }">
                </div>
                <div class="label">悲观</div>
              </div>
              <div class="chart-item">
                <div class="value">{{ TZBGParams.calculatedRules.futureReturns.neutral.annual }}</div>
                <div class="bar-col"
                     :style="{ height: getBarHeight(TZBGParams.calculatedRules.futureReturns.neutral.annual) }">
                </div>
                <div class="label">中性</div>
              </div>
              <div class="chart-item">
                <div class="value">{{ TZBGParams.calculatedRules.futureReturns.optimistic.annual }}</div>
                <div class="bar-col"
                     :style="{ height: getBarHeight(TZBGParams.calculatedRules.futureReturns.optimistic.annual) }">
                </div>
                <div class="label">乐观</div>
              </div>

            </div>
            <div class="chart-legend">年化收益率（%）</div>
          </div>

          <div class="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>情景</th>
                  <th>年化收益</th>
                  <th>{{ year }}年累计收益</th>
                  <th>{{ benjing }}</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr v-for="item in scenarios" :key="item.scenario">
                  <td>{{ item.scenario }}</td>
                  <td class="blue-text">{{ item.annualReturn }}</td>
                  <td>{{ item.cumulativeReturn }}</td>
                  <td>{{ item.finalValue }}</td>
                </tr> -->
                <tr>
                  <td>悲观（μ-σ）</td>
                  <td class="blue-text">{{ TZBGParams.calculatedRules.futureReturns.pessimistic.annual }}</td>
                  <td>{{ TZBGParams.calculatedRules.futureReturns.pessimistic.cumulative }}</td>
                  <td>{{ TZBGParams.calculatedRules.futureReturns.pessimistic.finalValue }}</td>
                </tr>
                <tr>
                  <td>中性（μ）</td>
                  <td class="blue-text">{{ TZBGParams.calculatedRules.futureReturns.neutral.annual }}</td>
                  <td>{{ TZBGParams.calculatedRules.futureReturns.neutral.cumulative }}</td>
                  <td>{{ TZBGParams.calculatedRules.futureReturns.neutral.finalValue }}</td>
                </tr>
                <tr>
                  <td>乐观（μ+σ）</td>
                  <td class="blue-text">{{ TZBGParams.calculatedRules.futureReturns.optimistic.annual }}</td>
                  <td>{{ TZBGParams.calculatedRules.futureReturns.optimistic.cumulative }}</td>
                  <td>{{ TZBGParams.calculatedRules.futureReturns.optimistic.finalValue }}</td>
                </tr>
              </tbody>
            </table>
            <div class="table-note">
              以上为按 {{ year }} 年投资期测算结果，实际收益受市场环境影响存在不确定性。
            </div>
          </div>
        </div>
      </section>
    </main>

    <section class="bottom-grid" v-if="content">
      <div class="section-title">
        <span></span>
        <h3>投顾专家建议</h3>
      </div>
      <div class="bottom-grid-cards">
        <section class="card card-blue">
          <div class="card-header">
            <div class="card-icon blue-icon">
              <span class="icon-text">1</span>
            </div>
            <div class="card-title-area">
              <h3>一、方案诊断与定性解读</h3>
              <p class="card-subtitle">收益可观，审慎外推</p>
            </div>
          </div>

          <p class="card-desc">{{ diagnosisParagraph }}</p>

          <div class="highlight-section">
            <div class="highlight-title">
              <span class="highlight-icon">!</span>
              <span>重点关注</span>
            </div>
            <ul class="highlight-list">
              <li v-for="(item, index) in focusItems" :key="index">
                <span class="check-icon">✓</span>
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
        </section>

        <section class="card card-orange">
          <div class="card-header">
            <div class="card-icon orange-icon">
              <span class="icon-text">2</span>
            </div>
            <div class="card-title-area">
              <h3>二、跟踪与再平衡纪律</h3>
              <p class="card-subtitle">以静制动，等待触发</p>
            </div>
          </div>

          <p class="card-desc">{{ trackingParagraph }}</p>

          <div class="highlight-section">
            <div class="highlight-title">
              <span class="highlight-icon orange-highlight">1</span>
              <span>调仓纪律</span>
            </div>
            <ul class="highlight-list">
              <li v-for="(item, index) in adjustRules" :key="index">
                <span class="check-icon orange-check">✓</span>
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
        </section>

        <section class="card card-green">
          <div class="card-header">
            <div class="card-icon green-icon">
              <span class="icon-text">3</span>
            </div>
            <div class="card-title-area">
              <h3>三、止盈止损与风险预案</h3>
              <p class="card-subtitle">分批兑现，压力降波动</p>
            </div>
          </div>

          <div class="subsection">
            <div class="subsection-title">
              <span class="subsection-icon action-icon">止</span>
              <span>核心持仓层</span>
            </div>
            <ul class="subsection-list">
              <li v-for="(item, index) in corePositionRules" :key="index">
                <span class="check-icon green-check">✓</span>
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>

          <div class="subsection">
            <div class="subsection-title">
              <span class="subsection-icon action-icon">险</span>
              <span>主动减仓信号</span>
            </div>
            <ul class="subsection-list">
              <li v-for="(item, index) in activeReduceSignals" :key="index">
                <span class="signal-icon">◎</span>
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>

          <div class="subsection">
            <div class="subsection-title">
              <span class="subsection-icon action-icon">行</span>
              <span>下一步行动</span>
            </div>
            <ul class="action-list">
              <li v-for="(item, index) in nextActions" :key="index">
                <span class="action-time">{{ item.time }}</span>
                <span>{{ item.action }}</span>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </section>

  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

function getSection (md, title) {
  const reg = new RegExp(`##\\s+${title}[\\s\\S]*?(?=\\n##\\s+|$)`)
  return md.match(reg)?.[0] || ''
}

function parseMarkdownTable (section) {
  const lines = section
    .split('\n')
    .map(line => line.trim())
    .filter(line => line.startsWith('|'))

  if (lines.length < 3) return []

  return lines.slice(2).map(row => {
    const cols = row
      .split('|')
      .map(col => col.trim())
      .filter(Boolean)

    return {
      scenario: cols[0],
      shortName: cols[0]?.replace('（', '\n（'),
      annualReturn: cols[1],
      cumulativeReturn: cols[2],
      finalValue: cols[3]
    }
  })
}

function parseChecklist (section) {
  const reg = /-\s+\[\s*\]\s+(.+?)：(.+)/g
  const result = []

  let match
  while ((match = reg.exec(section)) !== null) {
    result.push({
      time: match[1],
      action: match[2]
    })
  }

  return result
}

function parseBulletList (section) {
  const reg = /-\s+(.+)/g
  const result = []

  let match
  while ((match = reg.exec(section)) !== null) {
    result.push(match[1].trim())
  }

  return result
}

function getSubSection (section, title) {
  const reg = new RegExp(`\\*\\*${title}\\*\\*[\\s\\S]*?(?=\\n\\*\\*|$)`)
  return section.match(reg)?.[0] || ''
}

function getParagraph (section) {
  return section
    .split('\n')
    .map(line => line.trim())
    .filter(line => line && !line.startsWith('##') && !line.startsWith('**') && !line.startsWith('-'))
    .join('')
}

function formatTime () {
  const now = new Date()
  const y = now.getFullYear()
  const M = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  const h = String(now.getHours()).padStart(2, '0')
  const m = String(now.getMinutes()).padStart(2, '0')
  const s = String(now.getSeconds()).padStart(2, '0')
  return `${y}/${M}/${d} ${h}:${m}:${s}`
}

export default {
  name: 'TouzibaogaoMoban',
  props: {
    content: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      generateTime: formatTime(),
      TZBGParams: {},
      backtestResult: {},
      yaliceshiResult: {},
      verdict: '',//`verdict`：固定为 `"pass"`（基本通过）/ `"optimize"`（待优化）/ `"redo"`（建议重做）
      tishixinxi: ''
    }
  },
  computed: {
    // 期望年化收益率是否通过
    qwnhIsPass () {
      // let shiji = this.backtestResult.customerEvaluation.dimensions[0].actual
      // let mubiao = this.backtestResult.customerEvaluation.dimensions[0].target
      // let qwnh = Math.abs(shiji - mubiao) <= 0.2
      let qwnh = this.backtestResult.customerEvaluation.dimensions[0].passed
      console.log("期望年化收益率是否通过>", qwnh)
      return qwnh
    },
    //最大回撤是否通过
    zdhcIsPass () {
      // let shiji = this.yaliceshiResult.customerEvaluation.dimensions[0].actual
      // let mubiao = this.yaliceshiResult.customerEvaluation.dimensions[0].target
      // let zdhc = Math.abs(shiji - mubiao) <= 0.2
      let zdhc = this.yaliceshiResult.customerEvaluation.dimensions[0].passed
      console.log("最大回撤是否通过>", zdhc)
      return zdhc
    },
    // 投资期限是否通过
    tzqxIsPass () {
      // let shiji = this.backtestResult.customerEvaluation.dimensions[2].actual
      // let mubiao = this.backtestResult.customerEvaluation.dimensions[2].target
      // let tzqx = Math.abs(shiji - mubiao) <= 0.2
      let tzqx = this.backtestResult.customerEvaluation.dimensions[2].passed
      console.log("投资期限是否通过>", tzqx)
      return tzqx
    },
    // 流动性需求是否通过
    ldxxqIsPass () {
      let ldxxq = this.yaliceshiResult.customerEvaluation.dimensions[1].passed
      console.log("流动性需求是否通过>", ldxxq)
      return ldxxq
    },

    diagnosisSection () {
      return getSection(this.content, '一、方案诊断')
    },
    futureSection () {
      return getSection(this.content, '二、未来收益预期')
    },
    trackingSection () {
      return getSection(this.content, '二、跟踪与再平衡纪律')
    },
    stopLossSection () {
      return getSection(this.content, '三、止盈止损与风险预案')
    },
    scenarios () {
      return parseMarkdownTable(this.futureSection)
    },
    diagnosisParagraph () {
      return getParagraph(this.diagnosisSection)
    },
    trackingParagraph () {
      return getParagraph(this.trackingSection)
    },
    focusItems () {
      const focusSub = getSubSection(this.diagnosisSection, '重点关注')
      return parseBulletList(focusSub)
    },
    adjustRules () {
      const adjustSub = getSubSection(this.trackingSection, '调仓纪律')
      return parseBulletList(adjustSub)
    },
    corePositionRules () {
      const coreSub = getSubSection(this.stopLossSection, '核心持仓层')
      return parseBulletList(coreSub)
    },
    activeReduceSignals () {
      const signalSub = getSubSection(this.stopLossSection, '主动减仓信号')
      return parseBulletList(signalSub)
    },
    nextActions () {
      const actionSub = getSubSection(this.stopLossSection, '下一步行动')
      return parseChecklist(actionSub)
    },
    verdictClass () {
      switch (this.verdict) {
        case 'pass': return 'verdict-pass'
        case 'optimize': return 'verdict-optimize'
        case 'redo': return 'verdict-redo'
        default: return ''
      }
    },
    //年份
    year () {
      let riskResult = JSON.parse(localStorage.getItem('riskResult'))
      return riskResult.customerProfile.investmentHorizonYears || '8'
    },
    //本金
    benjing () {
      let backtestParams = JSON.parse(localStorage.getItem('backtestParams'))
      return backtestParams.initialCapital / 10000 + '万本金期末' || '100 万本金期末'
    }
  },
  created () {
    this.TZBGParams = JSON.parse(localStorage.getItem('TZBGParams'))
    this.backtestResult = JSON.parse(localStorage.getItem('backtestResult'))
    this.yaliceshiResult = JSON.parse(localStorage.getItem('yaliceshiResult'))
    /**
     * 1.通过：	最大回撤、投资期限、年化收益、流动性 四项全部达标
     * 2.待优化：最大回撤、投资期限全部达标；年化收益、流动性至少有一项未达标（含 1 项不达标、2 项都不达标两种情况）。
     * 3. 重做	满足任意一条即判定重做：最大回撤、投资期限任意一项不达标；
     */
    console.log("最大回测是否通过>", this.zdhcIsPass, "-投资期限是否通过>", this.tzqxIsPass, "-年化收益是否通过>", this.qwnhIsPass, "-流动性需求是否通过>", this.ldxxqIsPass)
    // 重做--满足任意一条即判定重做：最大回撤、投资期限任意一项不达标；
    if (!this.zdhcIsPass || !this.tzqxIsPass) {
      if (!this.zdhcIsPass) {
        this.tishixinxi = '最大回撤未达标，建议重做。'
      }
      else if (!this.tzqxIsPass) {
        this.tishixinxi = '投资期限未达标，建议重做。'
      }
      this.verdict = 'redo'
    }
    // 通过 --最大回撤、投资期限、年化收益、流动性 四项全部达标
    else if ((this.qwnhIsPass && this.zdhcIsPass && this.tzqxIsPass && this.ldxxqIsPass)) {
      this.tishixinxi = ' 已全部达标，无需优化。'
      this.verdict = 'pass'
    }

    // 待优化--最大回撤、投资期限全部达标；年化收益、流动性至少有一项未达标（含 1 项不达标、2 项都不达标两种情况）。
    else if ((!this.qwnhIsPass && this.zdhcIsPass && this.tzqxIsPass && this.ldxxqIsPass)
      || (this.qwnhIsPass && this.zdhcIsPass && this.tzqxIsPass && !this.ldxxqIsPass)
      || (!this.qwnhIsPass && this.zdhcIsPass && this.tzqxIsPass && !this.ldxxqIsPass)) {
      if (!this.qwnhIsPass) {// 期望年化未达标
        this.tishixinxi = this.backtestResult.customerEvaluation.dimensions[0].insight || ''
      }
      else if (!this.ldxxqIsPass) {//流动性未达标
        this.tishixinxi = this.yaliceshiResult.customerEvaluation.dimensions[1].insight || ''
      } else if (!this.qwnhIsPass && !this.ldxxqIsPass) {//期望年化 与 流动性都未达标
        this.tishixinxi = this.backtestResult.customerEvaluation.dimensions[0].insight + this.yaliceshiResult.customerEvaluation.dimensions[1].insight
      }
      this.verdict = 'optimize'
    }
  },
  methods: {
    liquidityNeed (name) {
      switch (name) {
        case 'High':
          return '高'
        case 'Medium':
          return '中'
        case 'Low':
          return '低'
        default:
          return '中'
      }
    },
    formatVerdict (verdict) {
      switch (verdict) {
        case 'pass':
          return '基本通过'
        case 'optimize':
          return '待优化'
        case 'redo':
          return '建议重做'
        default:
          return '未知'
      }
    },
    getBarHeight (percentText) {
      const value = Number(String(percentText).replace('%', ''))
      if (isNaN(value) || value <= 0) return '8%'
      const fr = this.TZBGParams?.calculatedRules?.futureReturns
      const maxVal = Math.max(
        Number(String(fr?.neutral?.annual || '0').replace('%', '')),
        Number(String(fr?.optimistic?.annual || '0').replace('%', '')),
        Number(String(fr?.pessimistic?.annual || '0').replace('%', ''))
      )
      if (maxVal <= 0) return '8%'
      return `${Math.max((value / maxVal) * 100, 8)}%`
    },
    generatePdfBlob () {
      return new Promise((resolve, reject) => {
        const el = this.$el
        const contentBox = el.parentNode
        const content = contentBox.parentNode

        // 保存父容器原始样式
        const cbOverflow = contentBox.style.overflow
        const cbHeight = contentBox.style.height
        const cOverflow = content.style.overflow
        const cHeight = content.style.height

        // 临时展开高度约束
        contentBox.style.overflow = 'visible'
        contentBox.style.height = 'auto'
        content.style.overflow = 'visible'
        content.style.height = 'auto'

        const restore = () => {
          contentBox.style.overflow = cbOverflow
          contentBox.style.height = cbHeight
          content.style.overflow = cOverflow
          content.style.height = cHeight
        }

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            html2canvas(el, {
              scale: 2,
              useCORS: true,
              allowTaint: false,
              logging: false
            }).then(canvas => {
              restore()
              const pdf = new jsPDF('p', 'mm', 'a4')
              const pageWidth = pdf.internal.pageSize.getWidth()
              const pageHeight = pdf.internal.pageSize.getHeight()
              const marginLeft = 10
              const marginTop = 10
              const pdfImgWidth = pageWidth - 20
              const pageContentHeight = pageHeight - 20

              const pxPerMm = canvas.width / pdfImgWidth
              const slicePxHeight = pageContentHeight * pxPerMm
              const totalPages = Math.ceil(canvas.height / slicePxHeight)

              for (let i = 0; i < totalPages; i++) {
                if (i > 0) pdf.addPage()
                const y = i * slicePxHeight
                const h = Math.min(slicePxHeight, canvas.height - y)

                const pageCanvas = document.createElement('canvas')
                pageCanvas.width = canvas.width
                pageCanvas.height = h
                const ctx = pageCanvas.getContext('2d')
                ctx.drawImage(canvas, 0, y, canvas.width, h, 0, 0, canvas.width, h)

                const pageImgData = pageCanvas.toDataURL('image/jpeg', 0.95)
                const pageImgHeight = (h * pdfImgWidth) / canvas.width
                pdf.addImage(pageImgData, 'JPEG', marginLeft, marginTop, pdfImgWidth, pageImgHeight)
              }

              resolve(pdf.output('blob'))
            }).catch(err => {
              restore()
              reject(err)
            })
          })
        })
      })
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.touzibaogao-moban {
  min-height: 100vh;
  padding: 28px 36px 96px;
  /* background:
    radial-gradient(circle at 20% 0%, rgba(59, 130, 246, 0.12), transparent 28%),
    linear-gradient(135deg, #f6f9ff 0%, #eef4ff 50%, #f8fbff 100%); */
  color: #172033;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "PingFang SC",
    "Microsoft YaHei",
    sans-serif;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 22px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 14px;
}

.logo {
  width: 38px;
  height: 38px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  color: #fff;
  font-weight: 800;
  background: linear-gradient(135deg, #1e88ff, #6c4cff);
  box-shadow: 0 10px 24px rgba(50, 105, 255, 0.25);
}

h1 {
  margin: 0;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.brand p,
.time {
  margin: 4px 0 0;
  color: #6b7891;
  font-size: 14px;
}

.hero-card {
  position: relative;
  overflow: hidden;
  border-radius: 24px;
  padding: 32px 36px;
  margin-bottom: 20px;
  background:
    linear-gradient(100deg, #fff 0%, #fff7f7 68%, #ffecec 100%);
  box-shadow: 0 14px 38px rgba(31, 56, 96, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hero-left {
  display: flex;
  align-items: center;
  gap: 26px;
  position: relative;
  z-index: 2;
}

.warn-icon {
  width: 86px;
  height: 86px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  font-size: 42px;
  font-weight: 800;
  background: linear-gradient(135deg, #ff4d4f, #ec2f3c);
  box-shadow: 0 16px 34px rgba(238, 57, 70, 0.28);

  &.verdict-pass {
    background: linear-gradient(135deg, #10b981, #059669);
    box-shadow: 0 16px 34px rgba(16, 185, 129, 0.28);
  }

  &.verdict-optimize {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    box-shadow: 0 16px 34px rgba(245, 158, 11, 0.28);
  }
}

.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 18px;
  border-radius: 999px;
  background: #ee3447;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 12px;

  &.verdict-pass {
    background: #10b981;
  }

  &.verdict-optimize {
    background: #f59e0b;
  }
}

.hero-card h2 {
  margin: 0;
  font-size: 28px;
  line-height: 1.45;
  font-weight: 800;
}

.hero-card h2 span {
  color: #e73546;
  font-size: 34px;
}

.verdict-pass h2 span {
  color: #10b981;
}

.verdict-optimize h2 span {
  color: #f59e0b;
}

.hero-card p {
  margin: 8px 0 0;
  color: #536177;
  line-height: 1.7;
}

.hero-graphic {
  position: relative;
  width: 210px;
  height: 120px;
  opacity: 0.55;
}

.bar {
  position: absolute;
  bottom: 20px;
  width: 28px;
  border-radius: 8px 8px 0 0;
  background: #ff8a8f;
}

.b1 {
  height: 46px;
  left: 36px;
}

.b2 {
  height: 76px;
  left: 78px;
}

.b3 {
  height: 58px;
  left: 120px;
}

.down-arrow {
  position: absolute;
  right: 6px;
  bottom: 10px;
  font-size: 88px;
  color: #ef4d5c;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  margin-bottom: 20px;
}

.kpi-card {
  display: flex;
  align-items: center;
  gap: 18px;
  min-height: 126px;
  padding: 22px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 10px 28px rgba(31, 56, 96, 0.07);
}

.kpi-icon {
  width: 62px;
  height: 62px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 50%;
  font-weight: 800;
  font-size: 22px;
}

.kpi-card p {
  margin: 0 0 4px;
  color: #647084;
  font-size: 15px;
}

.kpi-card strong {
  display: block;
  font-size: 30px;
  line-height: 1.2;
}

.pass-green {
  color: #10b981;
}

.pass-red {
  color: #e73546;
}

.kpi-card em {
  display: inline-block;
  margin-top: 8px;
  font-style: normal;
  font-size: 13px;
  color: #7a8597;
}

.danger .kpi-icon {
  color: #e73546;
  background: #ffe8eb;
}

.danger strong {
  /* color: #e73546; */
}

.blue .kpi-icon {
  color: #246bff;
  background: #eaf1ff;
}

.blue strong {
  /* color: #246bff; */
}

.green .kpi-icon {
  color: #14905c;
  background: #e6f8ef;
}

.green strong {
  /* color: #14905c; */
}

.orange .kpi-icon {
  color: #eb7a21;
  background: #fff0df;
}

.orange strong {
  /* color: #eb7a21; */
}

.main-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  margin-bottom: 18px;
}

.bottom-grid {
  display: flex;
  flex-direction: column;
}

.bottom-grid-cards {
  display: grid;
  grid-template-columns: 0.85fr 1.1fr 1.3fr;
  gap: 18px;
}

.card {
  border-radius: 22px;
  padding: 22px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 28px rgba(31, 56, 96, 0.07);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.section-title span {
  width: 4px;
  height: 22px;
  border-radius: 10px;
  background: #2d77ff;
}

.section-title h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
}

/* issues-card 根据判决结果联动标题条颜色 */
.verdict-redo.issues-card .section-title span {
  background: #e73546;
}

.verdict-pass.issues-card .section-title span {
  background: #10b981;
}

.verdict-optimize.issues-card .section-title span {
  background: #f59e0b;
}

.orange-title span {
  background: #ef8a24;
}

.card-blue {
  border-left: 4px solid #246bff;
}

.card-orange {
  border-left: 4px solid #eb7a21;
}

.card-green {
  border-left: 4px solid #14905c;
}

.issue-list {
  display: grid;
  gap: 12px;
}

.issue-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  border: 1px solid #edf1f8;
  border-radius: 16px;
  background: #fff;
}

.issue-icon {
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #f14a5d;
  color: #fff;
  font-weight: 800;
}

.issue-item h4 {
  margin: 0 0 3px;
  font-size: 16px;
}

.issue-item p {
  margin: 0;
  color: #69758a;
  font-size: 13px;
}

.income-content {
  display: grid;
  grid-template-columns: 0.85fr 1.35fr;
  gap: 20px;
  align-items: stretch;
}

.chart-box {
  padding: 10px;
  border-radius: 18px;
  background: #fbfdff;
}

.chart {
  height: 200px;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  border-left: 1px solid #dde5f2;
  border-bottom: 1px solid #dde5f2;
  padding: 10px 12px 0;
}

.chart-item {
  width: 70px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.value {
  font-weight: 800;
  color: #1b4fd8;
  margin-bottom: 8px;
}

.bar-col {
  width: 40px;
  margin: 0 auto 8px;
  min-height: 28px;
  border-radius: 10px 10px 0 0;
  background: linear-gradient(180deg, #1f72ff, #61b0ff);
}

.label {
  white-space: pre-line;
  color: #596579;
  font-size: 12px;
  line-height: 1.25;
}

.chart-legend {
  margin-top: 10px;
  text-align: center;
  color: #637085;
  font-size: 13px;
}

.table-wrap {
  overflow: hidden;
  border: 1px solid #e7edf6;
  border-radius: 16px;
  background: #fff;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

th {
  background: #f3f7fd;
  color: #253044;
  font-weight: 800;
}

th,
td {
  padding: 13px 12px;
  border-bottom: 1px solid #edf1f6;
  text-align: left;
}

tbody tr:last-child td {
  border-bottom: none;
}

.blue-text {
  color: #236cff;
  font-weight: 800;
}

.table-note {
  padding: 12px 14px;
  background: #f7faff;
  color: #657186;
  font-size: 13px;
}

.check-list,
.timeline {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 12px;
}

.check-list li,
.timeline li {
  position: relative;
  padding-left: 26px;
  color: #596579;
  line-height: 1.55;
  font-size: 14px;
}

.check-list li::before,
.timeline li::before {
  content: "✓";
  position: absolute;
  left: 0;
  top: 1px;
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #2d77ff;
  color: #fff;
  font-size: 11px;
}

.check-list b,
.timeline b {
  color: #172033;
  margin-right: 6px;
}

.rule-boxes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.rule-box {
  padding: 16px;
  border-radius: 16px;
  background: #fff8ef;
  border: 1px solid #ffdfbd;
}

.rule-box h4 {
  margin: 0 0 10px;
  color: #df6b10;
}

.rule-box p {
  margin: 6px 0;
  color: #5e6878;
  font-size: 14px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.card-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.blue-icon {
  background: #eaf1ff;
}

.orange-icon {
  background: #fff0df;
}

.green-icon {
  background: #e6f8ef;
}

.icon-text {
  font-size: 18px;
  font-weight: 800;
}

.blue-icon .icon-text {
  color: #246bff;
}

.orange-icon .icon-text {
  color: #eb7a21;
}

.green-icon .icon-text {
  color: #14905c;
}

.card-title-area {
  flex: 1;
}

.card-title-area h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.card-subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748b;
}

.card-desc {
  margin: 0 0 16px;
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

.highlight-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 12px;
}

.highlight-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.highlight-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #2d77ff;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.orange-highlight {
  background: #eb7a21;
}

.highlight-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.highlight-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.check-icon {
  color: #2d77ff;
  font-size: 12px;
  flex-shrink: 0;
}

.orange-check {
  color: #eb7a21;
}

.green-check {
  color: #14905c;
}

.subsection {
  margin-top: 12px;
}

.subsection-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.subsection-icon {
  color: #14905c;
  font-size: 12px;
}

.action-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #14905c;
  color: #fff;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subsection-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.subsection-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 4px 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.signal-icon {
  color: #14905c;
  font-size: 10px;
  flex-shrink: 0;
}

.action-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.action-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.action-time {
  background: #14905c;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  flex-shrink: 0;
}

.action-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 16px 36px 22px;
  display: flex;
  justify-content: center;
  gap: 18px;
  background: linear-gradient(180deg, rgba(246, 249, 255, 0), rgba(246, 249, 255, 0.95) 35%);
  backdrop-filter: blur(10px);
}

.action-bar button {
  height: 50px;
  min-width: 180px;
  padding: 0 28px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.primary {
  color: #fff;
  background: linear-gradient(135deg, #176dff, #604dff);
  box-shadow: 0 12px 24px rgba(45, 119, 255, 0.28);
}

.secondary {
  color: #246bff;
  background: #fff;
  border: 1px solid #bcd0ff;
}

.ghost {
  color: #526075;
  background: #fff;
  border: 1px solid #e0e7f2;
}

@media (max-width: 1100px) {
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .main-grid,
  .bottom-grid,
  .income-content {
    grid-template-columns: 1fr;
  }

  .hero-graphic {
    display: none;
  }
}

@media (max-width: 720px) {
  .touzibaogao-moban {
    padding: 20px 16px 120px;
  }

  .header {
    /* display: block; */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .time {
    margin-top: 8px;
  }

  .hero-card {
    padding: 24px;
  }

  .hero-left {
    /* display: block; */
    display: flex;
    /* flex-direction: column; */
    align-items: center;
  }

  .warn-icon {
    width: 64px;
    height: 64px;
    font-size: 32px;
    margin-bottom: 16px;
  }

  .hero-card h2 {
    font-size: 22px;
  }

  .hero-card h2 span {
    font-size: 28px;
  }

  .kpi-grid,
  .rule-boxes {
    grid-template-columns: 1fr;
  }

  .action-bar {
    display: grid;
    grid-template-columns: 1fr;
    padding: 14px 16px;
  }

  .action-bar button {
    width: 100%;
  }
}

/* 竖屏适配：KPI 卡片改为纵向堆叠，图标置顶 */
@media screen and (orientation: portrait) {
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .kpi-card {
    flex-direction: row;
    align-items: center;
    gap: 14px;
    min-height: auto;
    padding: 14px 16px;
    border-radius: 16px;
  }

  .kpi-icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    border-radius: 14px;
  }

  .kpi-card p {
    font-size: 13px;
    margin-bottom: 2px;
  }

  .kpi-card strong {
    font-size: 22px;
  }

  .kpi-card em {
    margin-top: 2px;
    font-size: 11px;
  }

  .bottom-grid-cards {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .subsection {
    margin-top: 8px;
  }

  .highlight-list li,
  .subsection-list li,
  .action-list li {
    font-size: 11px;
    padding: 3px 0;
  }

  .card-title-area h3 {
    font-size: 14px;
  }

  .card-desc {
    font-size: 12px;
  }
}

@media screen and (orientation: portrait) and (max-width: 480px) {
  .kpi-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .kpi-card {
    flex-direction: row;
    align-items: center;
    padding: 14px;
    gap: 12px;
  }

  .kpi-icon {
    width: 40px;
    height: 40px;
  }

  .kpi-card strong {
    font-size: 22px;
  }
}
</style>
